import config from "../config";

/**
 * Centralized Fetch wrapper that intercepts requests to automatically inject the Bearer token,
 * and intercepts 401 Unauthorized responses to trigger a logout.
 */
export const createApiClient = (token, logout) => {
  const fetchClient = async (endpoint, options = {}) => {
    const isLoggerPath = endpoint.includes("ClientSideApiErrorLogger/log");
    const url = endpoint.startsWith("http") ? endpoint : `${config.API_BASE_URL}${endpoint}`;
    
    const headers = new Headers(options.headers || {});
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    
    const fetchOptions = {
      ...options,
      headers
    };

    try {
      const response = await fetch(url, fetchOptions);

      // --- "Fire and Forget" Error Logging Interceptor ---
      if (!response.ok && !isLoggerPath) {
        try {
          // Clone the response to read the body without consuming the original stream
          const errorClone = response.clone();
          const serverMessage = await errorClone.text();
          
          const errorDetails = {
            url: url,
            status: response.status,
            serverMessage: serverMessage
          };

          // Silently post to the logging endpoint
          // Note: config.API_BASE_URL already contains '/api'
          fetch(`${config.API_BASE_URL}/ClientSideApiErrorLogger/log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(errorDetails)
          }).catch(() => { /* fail silently to avoid infinite loops */ });
        } catch (e) {
          /* fail silently */
        }
      }

      if (response.status === 401) {
        // Unauthorized - trigger logout and redirect
        logout();
        window.location.href = "/login?reason=expired";
        throw new Error("Session expired. Please log in again.");
      }
      
      return response;
    } catch (error) {
      // Catch Network/Fetch errors (e.g., DNS, Timeout)
      if (!isLoggerPath) {
        try {
          fetch(`${config.API_BASE_URL}/ClientSideApiErrorLogger/log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              url: url,
              status: 0,
              serverMessage: error.message || "Network Error"
            })
          }).catch(() => {});
        } catch (e) {}
      }
      throw error;
    }
  };

  return fetchClient;
};
